// vue
import { ref } from '@vue/composition-api';
import { useStore } from '@/store';

// hooks
import { useAxios } from '@/vue3/hooks/axiosHook';

// models
import { ImgTournament, LivePuttData } from '@/vue3/api/models';

export const useImgTournamentService = () => {
    // hooks
    const { apiUrl } = useStore().state;
    const axios = useAxios();

    // methods
    const getAllImgTournament = async (): Promise<ImgTournament[]> => {
        const res = await axios.get(`${apiUrl}/img/tournament`);
        return res.data;
    };

    const getLivePuttData = async (
        tournamentId: number,
        roundNo: number,
    ): Promise<LivePuttData[]> => {
        const res = await axios.get(
            `${apiUrl}/img/tournament/${tournamentId}/round/${roundNo}`,
        );
        return res.data;
    };

    const getAllImgPlayerByTournamentId = async (
        tournamentId: number,
    ): Promise<ImgTournament[]> => {
        const res = await axios.get(
            `${apiUrl}/img/tournament/${tournamentId}/player`,
        );
        return res.data;
    };

    return {
        getAllImgTournament,
        getAllImgPlayerByTournamentId,
        getLivePuttData,
    };
};
